<template>
    <CustomTopSheetDialog v-model="show" :width="600">
        <!-- Du hast bisher noch keine Nachrichten in deiner Inbox.
    Nach einer Anfrage kannst du hier deine Konversationen einsehen und beantworten. -->

        <template #title>
            <div class="d-flex align-center w-100">
                <v-icon @click="closeSheet" icon="mdi-close" size="x-small" />
                <div class="flex-grow-1 text-center">
                    <!-- {{ item }} -->
                    <h3 class="flex-grow-1 text-center" v-html="$t('shop.home.widgets.merchant-dialog.heading', {search: item?.name ? item?.name : item?.value})">
                    </h3>
                </div>
            </div>
        </template>
        <!-- <v-list v-if="!showProducers" class="dense-list" lines="one" active-class="" variant="text" density="compact"
            bg-color="transparent">
            <v-list-item v-for="(item, index) in sheetItems" :key="index" :ripple="false" class="py-0 dialog-list-item"
                @click="openProducerList(item)">
                <v-list-item-title v-if="sheetType == 'businessFilter'">{{
                    item.nameTranslations[selectedLanguage.toUpperCase()]
                }}</v-list-item-title>
                <v-list-item-title
                    v-else-if="sheetType == 'label' || sheetType == 'productGroup' || sheetType == 'productCategory'">{{
                        item.translations[selectedLanguage.toUpperCase()].value
                    }}</v-list-item-title>
                <v-list-item-title v-else-if="sheetType == 'Country'">{{
                    item.translations[selectedLanguage.toUpperCase()]
                }}</v-list-item-title>
                <template v-slot:append>
                    <v-icon>mdi-chevron-right</v-icon>
                </template>
            </v-list-item>
        </v-list> -->
        <v-list lines="one" active-class="" variant="text" bg-color="transparent">
            <v-list-item v-for="(item, index) in items" :key="index" :ripple="false"
                class="py-0 px-0 dialog-list-item mb-2" @click="openProfile(item.id)">
                <template v-slot:prepend>
                    <v-responsive max-height="80" max-width="160" class="mr-2" v-if="item.assets?.length">
                        <img height="72px" :src="`${$cloudFrontApi}${item?.assets[0]}/GALLERY_IPHONE6`" cover />
                    </v-responsive>
                </template>
                <template v-slot:title>
                    {{ item.name }}
                </template>
                <template v-slot:subtitle>
                    {{ item.tagline }}
                </template>
                <template v-slot:default>
                    {{ item.countryOfOrigin }}
                </template>
            </v-list-item>
        </v-list>
    </CustomTopSheetDialog>
</template>


<script>
import { getCurrentInstance, onMounted, ref } from 'vue';
export default {
    name: "ConfirmDeletionDialog",
    props: {
        modelValue: {
            type: Boolean,
            required: true,
        },
        items: {
            type: Array,
            required: true
        },
        item: {
            type: Object

        }
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const showProducers = ref(false);
        const producers = ref([]);
        const sheetType = ref('')

        const selectedCompanyFilter = ref(null)



        return {

        }
    },
    computed: {
        show: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
        sheetItems() {
            // Dynamically generate the path for the icon
            switch (this.sheetType) {
                case 'businessFilter':
                    return this.businessfilters

                case 'label':
                    return this.labels.filter(label => !label.name.includes("Made in"));
                case 'productGroup':
                    return this.productGroups;
                case 'productCategory':
                    return this.productCategories;
                case 'Country':
                    return this.getTrendingCountries(this.trendingMerchantCountries, this.countries)
                default:
                    return []
            }
        },
        sheetTitleTranslation() {
            switch (this.sheetType) {
                case 'businessFilter':
                    return "benefits"
                case 'label':
                    return "value";
                case 'productGroup':
                    return "trend"
                case 'productCategory':
                    return "category"
                case 'Country':
                    return "location"
                default:
                    return []
            }

        },
    },
    methods: {
        closeSheet() {
            this.show = false;
        },
        openProfile(id) {
            this.$router.push(`/fairling/${id}`)
            // this.$router.push(`/fairling/${this.item.merchant.id}/`);
        },
    },
};
</script>
<script setup>
import CustomTopSheetDialog from '@/components/custom/CustomTopSheetDialog.vue';
</script>
